import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

function editProjectInStorage(project) {
    if (typeof(Storage) !== "undefined" && project.id) {
        var projects = window.localStorage.getItem('projects');
        if(projects) {
            projects = JSON.parse(projects);
        } else {
            projects = [];
        }
        var projectIndex = projects.findIndex((eachProject) => eachProject.id===project.id);
        if(projectIndex!==-1) projects[projectIndex] = project;
        else projects.push(project);
        window.localStorage.setItem('projects', JSON.stringify(projects));
    }
}

function getProjectInStorage(projectId) {
    if (typeof(Storage) !== "undefined") {
        var projects = window.localStorage.getItem('projects');
        if(projects) {
            projects = JSON.parse(projects);
        } else {
            projects = [];
        }
        var projectIndex = projects.findIndex((eachProject) => eachProject.id===projectId);
        if(projectIndex!==-1) return projects[projectIndex];
        else return null;
    }
}

function removeProjectFromStorage(projectId) {
    if (typeof(Storage) !== "undefined") {
        var projects = window.localStorage.getItem('projects');
        if(projects) {
            projects = JSON.parse(projects);
        } else {
            projects = [];
        }
        var filteredProjects = projects.filter((project) => project.id!==projectId);
        window.localStorage.setItem('projects', JSON.stringify(filteredProjects));
        window.localStorage.removeItem('currentProjectId');
    }
}

export default new Vuex.Store({
  state: {
    project: {
        /* 
        {
            id: Number, 
            name: String, 
            releases: [
                id: Number,
                name: String
                stories: [
                    {
                        id: Number,
                        name: String
                        tags: [String],
                        points: Number
                    }
                ]
            ]
        }
         */
    },
    projects: [],
  },
  mutations: {
      setProject(state, {project}) {
          state.project = project;
      },
      addRelease(state, {release}) {
        state.project.releases.push(release);
      },
      updateRelease(state, {release}) {
        var releaseIndex = state.project.releases.findIndex(eachRelease => eachRelease.id == release.id);
        state.project.releases[releaseIndex] = release;
      },
      removeReleaseById(state, {releaseId}) {
          state.project.releases = state.project.releases.filter(release => release.id != releaseId);
      },
      addStoryToRelease(state, {releaseId, story}) {
            var release = state.project.releases.find(release => release.id == releaseId);
            release.stories.push(story);
      },
      removeStoryByIdFromRelease(state, {releaseId, storyId}) {
          var release = state.project.releases.find(release => release.id == releaseId);
          release.stories = release.stories.filter(story => story.id != storyId);
      },
      replaceStoryFromRelease(state, {releaseId, story}) {
          var release = state.project.releases.find(release => release.id == releaseId);
          var index = release.stories.findIndex(oldStory => story.id == oldStory.id);
          release.stories[index] = story;
      },
      setProjects(state, {projects}) {
          state.projects = projects;
      },
      addProject(state, {project}) {
          state.projects.push(project);
      },
      updateProjectName(state, {name}) {
          state.project.name = name;
      },
  },
  actions: {
        addRelease({commit, getters}, {release}) {
            var releases = getters.releases;
            var id = releases.reduce((accumulator, release) => release.id > accumulator ? release.id : accumulator, 0) + 1;
            release.id = id;
            commit('addRelease', {release});
            editProjectInStorage(getters.currentProject);
        },
        updateRelease({commit, getters}, {release}) {
            commit('updateRelease', {release});
            editProjectInStorage(getters.currentProject);
        },
        removeReleaseById({commit, getters}, {releaseId}) {
            commit('removeReleaseById', {releaseId});
            editProjectInStorage(getters.currentProject);
        },
        addStoryToRelease({commit, getters}, {releaseId, story}) {
            var releases = getters.releases;
            var release = releases.find(release => release.id == releaseId);
            var id = release.stories.reduce((accumulator, story) => story.id > accumulator ? story.id : accumulator, 0) + 1;
            story.id = id;
            commit('addStoryToRelease', {releaseId, story});
            editProjectInStorage(getters.currentProject);
        },
        removeStoryByIdFromRelease({commit, getters}, {releaseId, storyId}) {
            commit('removeStoryByIdFromRelease', {releaseId, storyId});
            editProjectInStorage(getters.currentProject);
        },
        replaceStoryFromRelease({commit, getters}, {releaseId, story}) {
            commit('replaceStoryFromRelease', {releaseId, story});
            editProjectInStorage(getters.currentProject);
        },
        addProject({commit, getters}, project) {
            return new Promise((resolve) => {
                var projects = getters.projects;
                var id = projects.reduce((accumulator, project) => project.id > accumulator ? project.id : accumulator, 0) + 1;
                project.id = id;
                editProjectInStorage(project);
                commit('addProject', {project});
                resolve(project);
            });
        },
        getProject({commit}, projectId) {
            var project = getProjectInStorage(projectId);
            return new Promise((resolve) => {
                setTimeout(() => {
                    if(project) commit('setProject', {project});
                    resolve();
                }, 300);
            });
        },
        updateProjectName({commit, getters}, projectName) {
            var projectId = getters.currentProject.id;
            var project = getProjectInStorage(projectId);
            project.name = projectName;
            editProjectInStorage(project);
            commit('updateProjectName', {name: projectName});

            var projects = getters.projects;
            var projectIndex = projects.findIndex((eachProject) => eachProject.id === projectId);
            if(projectIndex!==-1) {
                projects[projectIndex].name = projectName;
            }
            commit('setProjects', {projects});
        },
        removeProject({commit, getters}, projectId) {
            return new Promise((resolve) => {
                removeProjectFromStorage(projectId);
                resolve();
            });
        }
  },
  getters: {
        currentProject(state) {
            return state.project;
        },
        projects(state) {
            return state.projects;
        },
        releases(state) {
            return state.project.releases;
            // return function(projectId) {
            //     var projectIndex = state.projects.findIndex(eachProject => eachProject.id == projectId);
            //     if(projectIndex!==-1) return state.project.releases;
            //     else return [];
            // }
        },
        storyPointsInReleaseByTag(state) {
            return function (releaseId, tag) {
                var release = state.project.releases.find(release => release.id == releaseId);
                if(release && release.stories) {
                    var stories = release.stories.filter(story => story.tags.includes(tag));
                    return stories.reduce((accumulator, story) => accumulator+story.points, 0);
                }
                return 0;
            }
        },
        estimatedTimeInReleaseByTag(state) {
            return function (releaseId, tag) {
                var release = state.project.releases.find(release => release.id == releaseId);
                if(release && release.stories) {
                    var stories = release.stories.filter(story => story.tags.includes(tag));
                    return stories.reduce((accumulator, story) => {
                        var meanDaysByStoryPoint = {
                            1: 0.5,
                            3: 1,
                            5: 2.5,
                            8: 5,
                            13: 10,
                            21: 17.5
                        };
                        return accumulator+meanDaysByStoryPoint[story.points];
                    }, 0);
                }
                return 0;
            }
        }
  }
});
